import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import stringUtils from "../../../_services/string-utils";
import { Alert } from "reactstrap";

const INFO = {
    identifier: "info",
};
const ERROR = {
    identifier: "danger",
};

const WARNING = {
    identifier: "warning",
};

const SUCCESS = {
    identifier: "success",
};

const MessageType = {
    INFO,
    ERROR,
    WARNING,
    SUCCESS,
};

export const ErrorMessage = (props) => {
    return <MessageComponent type={MessageType.ERROR} {...props} />;
};

export const WarningMessage = (props) => {
    return <MessageComponent type={MessageType.WARNING} {...props} />;
};

export const SuccessMessage = (props) => {
    return <MessageComponent type={MessageType.SUCCESS} {...props} />;
};

export const InfoMessage = (props) => {
    return <MessageComponent type={MessageType.INFO} {...props} />;
};

const MessageComponent = ({
    type,
    children,
    messages,
    style,
    isOpen,
    toggle,
    marginless = false,
    useTopMargin = false,
    useBottomMargin = true,
    "data-cy": dataCy,
}) => {
    const messageComponent = determineMessageContent(children, messages);

    if (messageComponent && (!Array.isArray(children) || children.length > 0)) {
        return (
            <AlertBoxWrapper
                color={type.identifier}
                isOpen={isOpen}
                toggle={toggle}
                data-cy={dataCy}
                style={{ ...style, ...prepareMarginStyle(marginless, useTopMargin, useBottomMargin) }}
            >
                {messageComponent}
            </AlertBoxWrapper>
        );
    } else {
        return <></>;
    }
};

const MessageContent = ({ message }) => {
    return <div dangerouslySetInnerHTML={{ __html: message }} />;
};

const determineMessageContent = (children, messages) => {
    if (children) {
        if (typeof children === "string" && !stringUtils.isBlank(children)) {
            return <MessageContent message={children} />;
        } else if (Array.isArray(children) && children.length > 0) {
            return children;
        } else {
            return children;
        }
    } else if (!stringUtils.isBlank(messages)) {
        if (typeof messages === "string") {
            return <MessageContent message={messages} />;
        } else if (Array.isArray(messages) && messages.length > 0) {
            return messages;
        } else {
            return messages;
        }
    }
};

const prepareMarginStyle = (marginless, useTopMargin, useBottomMargin) => {
    return {
        marginTop: marginless ? "0" : useTopMargin ? "1rem" : "0",
        marginBottom: marginless ? "0" : useBottomMargin ? undefined : "0",
    };
};

const AlertBoxWrapper = styled(Alert)`
    white-space: pre-line;

    & > p {
        margin: 0;
    }
`;

const MessagePropTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    style: PropTypes.object,
    marginless: PropTypes.bool,
    useTopMargin: PropTypes.bool,
    useBottomMargin: PropTypes.bool,
    messages: PropTypes.string,
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    "data-cy": PropTypes.string,
};

MessageComponent.propTypes = {
    type: PropTypes.oneOf([MessageType.INFO, MessageType.ERROR, MessageType.WARNING, MessageType.SUCCESS]).isRequired,
    ...MessagePropTypes,
};

ErrorMessage.propTypes = {
    ...MessagePropTypes,
};

WarningMessage.propTypes = {
    ...MessagePropTypes,
};

SuccessMessage.propTypes = {
    ...MessagePropTypes,
};

InfoMessage.propTypes = {
    ...MessagePropTypes,
};
